import script from "./get-vebal.vue?vue&type=script&setup=true&lang=ts"
export * from "./get-vebal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__